import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n *\n */\n/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n * \n */\n.vai-list-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 40px;\n  width: 100%;\n  border-bottom: 1px solid #e8e8e8;\n  box-sizing: border-box;\n}\n.vai-list-item:focus {\n  outline: none;\n  box-shadow: 0px 0px 5px 0px rgba(26, 180, 226, 0.5);\n}";
styleInject(css_248z);

export { css_248z as default };
